import React, { useRef } from "react";
import myPost from "../../assets/dashboard/mypost.png";
import preview from "../../assets/draft/preview.png";
import leftArrow from "../../assets/scoreBoard/left-arrow.svg";
import rightArrow from "../../assets/scoreBoard/right-arrow.svg";
import upload from "../../assets/navbar/draft.svg";
import likes from "../../assets/posts/likes.svg";
import comment from "../../assets/posts/comment.svg";
import repost from "../../assets/posts/repost.svg";

const posts = [
  {
    id: 1,
    image: preview,
    likes: 25,
    comments: 15,
    shares: 24,
  },
  {
    id: 2,
    image: myPost,
    likes: 25,
    comments: 15,
    shares: 24,
  },
  {
    id: 3,
    text: "🚀 Exciting news! Last week I started working on something new—a model inspired by lunar rhythms...",
    likes: 25,
    comments: 15,
    shares: 24,
  },
];

const MyTopPost = () => {
  const scrollRef = useRef(null);

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount =
        direction === "left" ? -clientWidth / 2 : clientWidth / 2;
      scrollRef.current.scrollTo({
        left: scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="border border-gray-200 rounded-2xl p-2 md:p-4 shadow-sm bg-white">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 border-b border-black-40">
        <h2 className="font-bold text-lg text-black-800 uppercase">
          My Top Posts
        </h2>
        <button className="p-3 mb-2 bg-black-0 hover:bg-black-20 focus:bg-black-40 border-2 border-black-600 rounded group relative">
          <img src={upload} alt="upload" />
          <div className="absolute top-12 left-1/2 -translate-x-1/2 mr-2 px-2 py-1 bg-gray-800 text-white text-xs shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-nowrap uppercase">
            Upload
            <div className="absolute left-1/2 bottom-full border-4 border-transparent border-b-gray-800"></div>
          </div>
        </button>
      </div>

      {/* Filters */}
      <div className="space-y-4 mb-4">
        <div>
          <label className="block text-lg font-bold text-black-800 mb-1">
            Industry
          </label>
          <select className="w-full h-[42px] border border-black-600 rounded px-3 py-2 text-lg text-black-50 focus:outline-none cursor-pointer">
            <option>Select</option>
          </select>
        </div>
        <div>
          <label className="block text-lg font-bold text-black-800 mb-1">
            Keyword
          </label>
          <input
            type="text"
            placeholder="Write the keyword"
            className="w-full h-[42px] border border-black-600 rounded px-3 py-2 text-lg text-black-600 placeholder:text-black-50 focus:outline-none"
          />
        </div>
      </div>

      {/* Posts Carousel */}
      <div
        ref={scrollRef}
        className="flex overflow-x-auto scrollbar-hide space-x-3 scroll-smooth"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {posts.map((post) => (
          <div
            key={post.id}
            className="border bg-black-20 rounded-xl min-w-[200px] max-w-[240px] flex-shrink-0 relative"
          >
            {post.image ? (
              <div className="w-full h-[180px] bg-gray-100 rounded-t-xl overflow-hidden flex items-center justify-center">
                <img
                  src={post.image}
                  alt="Post"
                  className="w-full h-full object-contain"
                />
              </div>
            ) : (
              <p className="p-1 h-[180px] text-sm text-black-800">{post.text}</p>
            )}
            <div className="flex justify-center px-3 py-2 text-xs text-black-400 space-x-2">
              <span className="flex gap-1">
                {post.likes}
                <img src={likes} alt="likes" /> •
              </span>
              <span className="flex gap-1">
                {post.comments}
                <img src={comment} alt="comment" /> •
              </span>
              <span className="flex gap-1">
                {post.shares}
                <img src={repost} alt="repost" />
              </span>
            </div>
            <span className="absolute top-2 left-2 bg-black-40 rounded-full w-8 h-8"></span>
          </div>
        ))}
      </div>

      {/* Pagination Arrows */}
      <div className="flex justify-end space-x-2 mt-2">
        <button
          onClick={() => handleScroll("left")}
          className="p-2 rounded border-2 border-black-600 shadow-sm w-8 h-8"
        >
          <img src={leftArrow} alt="leftArrow" />
        </button>
        <button
          onClick={() => handleScroll("right")}
          className="p-2 rounded border-2 border-black-600 shadow-sm w-8 h-8"
        >
          <img src={rightArrow} alt="rightArrow" />
        </button>
      </div>
    </div>
  );
};

export default MyTopPost;
